module.exports = __webpack_public_path__ + "media/images/icons/call-missed-92c6a3aea7e8c2b84444cabeb79337a4.svg";